<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px'
    window.htmlFontSize = document.documentElement.clientWidth / 7.5
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
* {
  padding: 0;
  margin: 0;
  font-size: 0.28rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue